<template>
  <div class="shop-page">
    <top-bar :topbarList="shopTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";

import { shopIndexMixins } from "@/mixins/shopIndexMixins";

export default {
  mixins: [shopIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.shop-page {
  height: 100%;
}
</style>
